import { gql } from '@apollo/client';

export const GET_TITLE_BY_WRITER_ID = gql`
  query titlesAsWriter(
    $writerId: String!
    $limit: Int
    $offset: Int
    $dateStart: DateTime
    $dateEnd: DateTime
    $searchText: String
    $status: Int
    $writers: [String!]
    $byPublishPost: Boolean
  ) {
    titlesAsWriter(
      writerId: $writerId
      filter: {
        limit: $limit
        offset: $offset
        dateStart: $dateStart
        dateEnd: $dateEnd
        searchText: $searchText
        status: $status
        writers: $writers
        byPublishPost: $byPublishPost
      }
    ) {
      titles {
        id
        title
        writerId
        status
        comments
        createdAt
        researchLinks
        suggestedKeywords
        countries
        status
        postUrl
        publishPost
        language
        deadline
      }
      permissions {
        hasWorking
        statusCanBeOpened
        showAddTitle
        showPagination
        showWriters
        showStatus
        showBackDate
        showPublishNow
        showCountries
        showAddCategories
        statusToRejectReason
        reasonToOtherReason
        showSitesFilter
        showWritersFilter
        showBrandsTitles
        showProductsTitles
        validations
      }
      total
    }
  }
`;

export const GET_TITLE_BY_REVIEWER_ID = gql`
  query titlesAsReviewer(
    $limit: Int
    $offset: Int
    $dateStart: DateTime
    $dateEnd: DateTime
    $searchText: String
    $sites: [String!]
    $status: Int
    $writer: String
    $byPublishPost: Boolean
  ) {
    titlesAsReviewer(
      filter: {
        limit: $limit
        offset: $offset
        dateStart: $dateStart
        dateEnd: $dateEnd
        searchText: $searchText
        sites: $sites
        status: $status
        writer: $writer
        byPublishPost: $byPublishPost
      }
    ) {
      titles {
        id
        title
        writerId
        status
        comments
        createdAt
        researchLinks
        suggestedKeywords
        countries
        status
        postUrl
        publishPost
        language
        deadline
      }
      permissions {
        statusCanBeOpened
        showAddTitle
        showSitesFilter
        showWritersFilter
        validations
      }
      total
    }
  }
`;

export const EDIT_TITLE_BY_WRITER_ID = gql`
  mutation updateTitleAsWriter(
    $id: String!
    $status: Int!
    $writerId: String!
  ) {
    updateTitleAsWriter(
      id: $id
      input: { status: $status, writerId: $writerId }
    ) {
      id
      title
      writerId
      status
      comments
      createdAt
    }
  }
`;

export const CHECK_IF_TITLE_HAS_WRITER = gql`
  query checkHasWriter($id: String!, $writerId: String!) {
    checkHasWriter(id: $id, writerId: $writerId) {
      hasWriter
    }
  }
`;
